import PoliciesRequired from './PoliciesRequired'

export default PoliciesRequired
